import React, { Component } from "react";
import {
  Table,
  Translate,
  Pagination,
  Breadcrumb,
  Input,
  Row,
  Col,
  FormField,
  Select,
  Form,
  Icon,
  Button,
  Spinner,
  Modal,
} from "$common";
import style from "./submissions.scss";
import { Link } from "react-router";
import Filters from "./filters/filters";
import CSSModules from "react-css-modules";

let customColumns = undefined;
let columns = [];
let customColumnFilterOptions = [];
@CSSModules(style)
export default class Submissions extends Component {
  state = {
    changes: [],
    filters: this.props.filters,
    hasCustomColumn: false,
    isModalOpen: false,
    selectedEmails: [],
  };

  renderCustomColumns() {
    const { submissions } = this.props;

    customColumns = undefined;

    columns = [
      {
        label: "ID",
        key: "id",
        width: "1/7",
        sortKey: "id",
      },
      {
        label: `${Translate.get("task_title")}`,
        content: (item) => (
          <Link to={`/project/${this.props.projectId}/submissions/${item.id}`}>
            {item.task.title}
          </Link>
        ),
        width: "5/10",
      },
      {
        label: `${Translate.get("submitted_at")}`,
        key: "created_at",
        width: "2/10",
        type: "date",
        sortKey: "created_at",
      },
    ];

    if (submissions.length > 0) {
      if (submissions[0].task.custom_fields.length > 0) {
        if (!this.state.hasCustomColumn)
          this.setState({ hasCustomColumn: true });

        customColumns = [];
        customColumnFilterOptions = [];

        submissions.map((submission) => {
          submission.task.custom_fields.map((field) => {
            if (!customColumns[field.key]) {
              customColumns[field.key] = {
                label: field.key,
                customColumnKey: field.key,
                width: "2/18",
              };
              customColumnFilterOptions.push({
                label: field.key,
                value: field.key,
              });
            }
          });
        });
      } else {
        columns = [
          {
            label: "ID",
            key: "id",
            width: "2/10",
            sortKey: "id",
          },
          {
            label: `${Translate.get("task_title")}`,
            content: (item) => (
              <Link
                to={`/project/${this.props.projectId}/submissions/${item.id}`}
              >
                {item.task.title}
              </Link>
            ),
            width: "6/10",
          },
          {
            label: `${Translate.get("submitted_at")}`,
            key: "created_at",
            width: "2/10",
            type: "date",
            sortKey: "created_at",
          },
        ];
      }

      if (
        columns[0].label !== Translate.get("total_answer_points") &&
        submissions[0].total_answer_points !== null
      ) {
        columns.map((column) => {
          if (column.label === Translate.get("total_answer_points")) {
            delete columns[columns.indexOf(column)];
          }
        });

        columns.unshift({
          label: `${Translate.get("total_answer_points")}`,
          key: "total_answer_points",
          width: "1/10",
          sortKey: "total_answer_points",
          style: {
            textAlign: "center",
          },
        });
      } else {
        columns[1].width = "6/10";
      }
    }
  }

  handleFilterChange(key, val, isCustomColumnFilter = false) {
    const { changes, filters } = this.state;

    if (!changes.includes(key)) changes.push(key);
    filters[key] = val;

    this.setState({ changes, filters });

    clearTimeout(this.state.timeouts);

    this.setState({
      timeouts: setTimeout(
        function () {
          if (isCustomColumnFilter) {
            if (filters.custom_key_eq !== null)
              this.props.onFilterChange("custom_key_eq", filters.custom_key_eq);
            if (filters.custom_key_value_eq !== null)
              this.props.onFilterChange(
                "custom_key_value_eq",
                filters.custom_key_value_eq
              );
          } else {
            this.props.onFilterChange(key, val);
          }
          this.setState({ changes: [] });
        }.bind(this),
        700
      ),
    });
  }

  clearFilters() {
    this.props.onFilterChange("page", this.state.filters.page || 1);
    this.setState({ changes: [], filters: [] });
  }

  handleEmailSelection = (email, isSelected) => {
    this.setState((prevState) => {
      const selectedEmails = new Set(prevState.selectedEmails);
      if (isSelected) {
        selectedEmails.add(email);
      } else {
        selectedEmails.delete(email);
      }
      return { selectedEmails: Array.from(selectedEmails) };
    });
  };

  handleOpenModal = () => {
    this.setState({ isModalOpen: true });
  };

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleSubmit = () => {
    this.props.createReportForReporters({
      type: "xls",
      selectedEmails: this.state.selectedEmails,
    });
    this.handleCloseModal();
  };

  render() {
    const {
      submissions,
      currentPage,
      totalCount,
      onFilterChange,
      filters,
      createReport,
      project,
    } = this.props;
    const { hasCustomColumn, isModalOpen, selectedEmails } = this.state;
    const reportEmails = this.props.account.reportEmails || [];

    this.renderCustomColumns();

    return project ? (
      <div>
        <Row>
          <Col md="25/30">
            <Filters
              filters={filters}
              onFiltersChange={onFilterChange}
              onClearFilters={::this.clearFilters}
              defaultFilters={
                <FormField>
                  <Input
                    placeholder="Task Title"
                    value={this.state.filters.task_title_cont || ""}
                    onChange={(value) =>
                      this.handleFilterChange("task_title_cont", value)
                    }
                    forceOnChange
                  />
                </FormField>
              }
              advancedFilters={
                hasCustomColumn ? (
                  <Row>
                    <Col md="1/2">
                      <FormField label="Key">
                        <Select
                          options={customColumnFilterOptions}
                          value={this.state.filters.custom_key_eq}
                          onChange={(value) =>
                            this.handleFilterChange(
                              "custom_key_eq",
                              value,
                              true
                            )
                          }
                        />
                      </FormField>
                    </Col>
                    <Col md="1/2">
                      <FormField label="Value">
                        <Input
                          value={this.state.filters.custom_key_value_eq || ""}
                          onChange={(value) =>
                            this.handleFilterChange(
                              "custom_key_value_eq",
                              value,
                              true
                            )
                          }
                          forceOnChange
                        />
                      </FormField>
                    </Col>
                  </Row>
                ) : (
                  ""
                )
              }
            />
          </Col>
          {reportEmails && reportEmails.length > 0 ? (
            <Col md="5/30">
              <Button onClick={this.handleOpenModal} type="ghost" block>
                <span style={{ marginRight: "10px", display: "inline-block" }}>
                  {Translate.get("export_report_custom_emails")}
                </span>
                <Icon name="cloud-download" />
              </Button>
              <Modal
                isOpen={isModalOpen}
                closeable={true}
                showHeader={true}
                title={Translate.get("select_emails")}
                size="small"
                onCloseRequest={this.handleCloseModal}
                styleName="modal-content"
              >
                <Form onSubmit={this.handleSubmit} style={{ padding: "20px" }}>
                  <ul styleName="email-list">
                    {reportEmails.map((email) => (
                      <li key={email}>
                        <label>
                          <input
                            type="checkbox"
                            checked={selectedEmails.includes(email)}
                            onChange={(e) =>
                              this.handleEmailSelection(email, e.target.checked)
                            }
                            style={{ marginRight: "10px" }}
                          />
                          {email}
                        </label>
                      </li>
                    ))}
                  </ul>
                  <Input
                    type="submit"
                    value={Translate.get("submit")}
                    styleName="submit-button"
                  />
                </Form>
              </Modal>
            </Col>
          ) : (
            <Col md="5/30">
              <Form onSubmit={createReport} defaults={{ type: "xls" }}>
                <Button type="ghost" submit block>
                  <span
                    style={{ marginRight: "10px", display: "inline-block" }}
                  >
                    {Translate.get("export_report")}
                  </span>
                  <Icon name="cloud-download" />
                </Button>
              </Form>
            </Col>
          )}
        </Row>

        <Table
          columns={columns}
          detailedColumns={customColumns}
          data={submissions}
          currentOrder={filters.s}
          onChangeOrder={(order) => onFilterChange("s", order)}
        />

        <Pagination
          totalRecords={totalCount}
          value={currentPage}
          onPageChange={(page) => {
            onFilterChange("page", page.selected + 1);
            // window.Intercom('trackEvent', 'CHANGED_SUBMISSIONS_PAGE', { project_id: project.id });
          }}
        />
      </div>
    ) : (
      <Spinner block center fullPage />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/project/show/submissions/submissions.js